import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store/store"

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();


const __returned__ = { store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})